import React, { lazy, Suspense } from 'react';
import { Container } from 'react-bootstrap';
import { Route, Routes } from 'react-router';
import Loading from '../shared/components/loading';

const NotAuthenticated = lazy(() => import('../pages/not-authenticated'));

const RoutesNotAuthenticated = () => {
  return (
    <Container>
      <Suspense fallback={<Loading message="loading.page" />}>
        <Routes>
          <Route path="/unauthorized" element={<NotAuthenticated />} />
          <Route path="*" element={<NotAuthenticated />} />
        </Routes>
      </Suspense>
    </Container>
  );
};

export default RoutesNotAuthenticated;
